
import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Cookies from 'js-cookie';
import * as moment from "moment";
import storage from "local-storage-fallback";

const tokenName: string = 'lap_image_browser';
const tokenHeader: string = 'X-Token';

const templateSettings: object = {
    evaluate: /<@([\s\S]+?)@>/g,
    interpolate: /<@=([\s\S]+?)@>/g,
    escape: /<@-([\s\S]+?)@>/g,
};

@Options({
    template: false,
    ui: {
        pressLoginForm: "[data-js-ui=pressLoginForm]",
    }
})
export default class PressLoginView extends Marionette.View<Backbone.Model>{
    config?: object;
    authenticationToken: string = null;

    constructor(options?:object, config?:object) {
        super(options);

        this.config = config || {};

        this.authenticationToken = storage.getItem(tokenName) || '';
    }

    onRender() {
        this.isLoggedIn().then(() => {
            window.location.href = '/press/images';
        }).catch((error) => {
            this.showLogin(error);
        });
    }

    @on("submit @ui.pressLoginForm")
    onFormSubmit(e) {
        e.preventDefault();

        const config = this.ajaxConfig('/press/authenticate', 'POST');

        config.data = $(e.currentTarget).serialize();

        $.ajax(config).done((response) => {
            // Store the ash
            storage.setItem(tokenName, response.data);

            // All good
            window.location.href = '/press/images';
        }).fail((xhr) => {
            alert(xhr.responseJSON.data);
        });
    }

    showLogin(response) {
        const loginView = new LoginFormView({
            form: {
                username: {
                    idForLabel: 'id_username',
                    label: 'Username',
                    error: '',
                },
                password: {
                    idForLabel: 'id_password',
                    label: 'Password',
                    error: '',
                }
            },
            next: '???',
            loginURL: '/press/images',
            passwordResetURL: '/press/images',
        });

        loginView.render();
    }

    ajaxConfig(url: string, method: string = 'GET') {
        const config = {
            url: url,
            method: method,
            headers: {},
            data: null,
        };

        config.headers[tokenHeader] = this.authenticationToken;

        return config;
    }

    isLoggedIn() {
        let deferred = $.Deferred();

        const config = this.ajaxConfig('/press/authenticated');

        $.ajax(config).done(() => {
            deferred.resolve(true);
        }).fail(() => {
            deferred.reject(false);
        });

        return deferred.promise();
    }
}

const LoginFormView = Marionette.View.extend({
    el: "[data-js-ui=press-login]",

    render: function() {
        const template = _.template(
            $('#press-login').html(), templateSettings
        );

        this.$el.html( template(this.options) );
    }
})



// WEBPACK FOOTER //
// ./@modules/views/press-login-view.ts